var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.8571 2H4.14286C2.95982 2 2 2.95982 2 4.14286V19.8571C2 21.0402 2.95982 22 4.14286 22H19.8571C21.0402 22 22 21.0402 22 19.8571V4.14286C22 2.95982 21.0402 2 19.8571 2ZM17.6741 9.08929C17.683 9.21429 17.683 9.34375 17.683 9.46875C17.683 13.3393 14.7366 17.7991 9.35268 17.7991C7.69196 17.7991 6.15179 17.317 4.85714 16.4866C5.09375 16.5134 5.32143 16.5223 5.5625 16.5223C6.93304 16.5223 8.19196 16.058 9.19643 15.2723C7.91071 15.2455 6.83036 14.4018 6.45982 13.2411C6.91071 13.308 7.31696 13.308 7.78125 13.1875C6.44196 12.9152 5.4375 11.7366 5.4375 10.3125V10.2768C5.82589 10.4955 6.28125 10.6295 6.75893 10.6473C6.35733 10.3802 6.02812 10.0178 5.80066 9.59248C5.5732 9.16716 5.45457 8.69214 5.45536 8.20982C5.45536 7.66518 5.59821 7.16518 5.85268 6.73214C7.29464 8.50893 9.45982 9.66964 11.8884 9.79464C11.4732 7.80804 12.9598 6.19643 14.7455 6.19643C15.5893 6.19643 16.3482 6.54911 16.8839 7.12054C17.5446 6.99554 18.1786 6.75 18.7411 6.41518C18.5223 7.09375 18.0625 7.66518 17.4554 8.02679C18.0446 7.96429 18.6161 7.79911 19.1429 7.57143C18.7455 8.15625 18.2455 8.67411 17.6741 9.08929Z",
    fill: "#93939B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.fe647b2c5c770914aef66df8e312bdd7.svg";
export { ForwardRef as ReactComponent };